module.exports = __webpack_public_path__ + "img/card.d383292a.jpg";